import React from 'react';
import BottomSection from '../components/BottomSection';
import { useSeo } from '../seo';

const timelineItems = [
  '2018年：上海蜜田科技有限公司成立于上海，通过与国内高端百货达成战略联盟，开创国内首个“折扣信息+专柜买手+正品保障”的美妆平台-【价探PriceTag】。',
  '2022年：价探PriceTag全面切入即时零售赛道，结合即时零售平台，持续创新科技手段，通过数字化赋能，自研中台系统，主营8大核心品类，帮助国内消费者以最便捷最优惠的方式购买到放心正品。',
  '2026年：价探PriceTag线下仓店超400家，与上百家美妆个护品牌达成战略合作。',
];

const businessItems = [
  '8大经营核心品类：彩妆香水、大牌护肤、个人护理、女性护理、差旅一次性、美妆工具、面膜修护、家清纸品。',
  '正品保证体系：品牌连锁、正品保证、实力保障、货源保障、入仓全检、官方授权、全球探美、售后服务、线上线下、万千信任。',
  '发展表现：7年美妆深耕，仓店 400+，覆盖百城，线上门店 1000+，私域交易额 2.5 亿+。',
  '行业背书：2025年价探PriceTag福布斯2025大消费年度影响力零售商、2025年 美团闪购年度最佳合作伙伴2026年 2025-2026年度连锁行业新锐品牌。',
  '相关资质：价探PriceTag为上海市高新技术企业、获商务部特许经营备案许可证（备案号：0311200112400132）。',
];

const cultureItems = [
  ['企业愿景', '成为年轻人身边的即时美好生活品牌。'],
  ['企业使命', '让美好生活所需，随时就在身边。'],
  ['核心价值观', '真、选、快、值、赢。'],
  ['真', '正品真货，是价探的底线。'],
  ['选', '每一件商品都认真挑选，品牌品选趋势、爆品、好价格；生活品选大厂同源，高质价比。'],
  ['快', '看到机会快速上新，发现问题快速调整，抓住即时零售的每一个需求窗口。'],
  ['值', '不只追求低价，而是让用户买到真正质价比好物。'],
  ['赢', '让用户、门店、品牌、团队，都因为价探获得更好的结果。'],
];

const honorItems = [
  '2021年7月 价探PriceTag获中国百货商业协会 会员单位',
  '2022年 价探PriceTag获美团闪购年度成长之星',
  '2023年 价探PriceTag获美团闪购年度探索突破奖',
  '2024年3月 价探PriceTag获沙利文 2024 年大消费年度新锐企业',
  '2024年3月 价探PriceTag获沙利文 2024大消费年度影响力连锁品牌',
  '2024年 价探PriceTag获仪美尚年度线下渠道科学选品团',
  '2025年3月 价探PriceTag获沙利文 2025 大消费年度影响力连锁品牌-调色集',
  '2025年 价探PriceTag获美团配送美妆垂类仓店新锐力量',
  '2025年 价探PriceTag获福布斯 2025 大消费年度影响力零售商',
  '2025年 价探PriceTag获CiE 新生力渠道年度最具竞争力即时零售',
  '2025年 价探PriceTag获美团闪购年度最佳合作伙伴',
  '2025年 价探PriceTag获线下趋势 Link 大会新零售风云榜',
  '2025年 价探PriceTag获SUPERLINKER 跨界新势力',
  '2025年 价探PriceTag获TwinkleColor 虹桥新天地会员共创奖',
  '2025年12月 价探PriceTag获中国美妆网 2025 中国美妆即时零售标杆闪电仓品牌',
  '2026年 价探PriceTag获上海市闵行区广告协会副会长单位',
  '2026年 价探PriceTag获CiE 全渠道年度最具影响力即时零售',
  '2026年 价探PriceTag获第17届仪美尚年度领军美妆即时零售品牌',
  '2026年 价探PriceTag获2025-2026 年度连锁行业新锐品牌',
];

type NewsArticlePageProps = {
  onNavigate: (href: string) => void;
};

function NewsArticlePage({ onNavigate }: NewsArticlePageProps) {
  useSeo('newsArticleDouyinBaike6');

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
      return;
    }

    onNavigate('/news');
  };

  return (
    <main className="news-article-page">
      <section className="news-article-shell">
        <button className="news-article-back" type="button" onClick={handleBack}>
          返回
        </button>

        <article className="news-article-card">
          <header className="news-article-header">
            <h1>价探PriceTag</h1>
            <p className="news-article-subtitle">
              价探PriceTag是上海蜜田科技有限公司旗下美妆个护即时零售头部品牌，30 分钟达・正品保障・全平台覆盖・美妆个护全品类。
            </p>
          </header>

          <section className="news-article-meta-grid">
            <div>
              <span>公司名称</span>
              <strong>上海蜜田科技有限公司</strong>
            </div>
            <div>
              <span>成立时间</span>
              <strong>2018年6月14日</strong>
            </div>
            <div>
              <span>总部地点</span>
              <strong>上海</strong>
            </div>
            <div>
              <span>法定代表人</span>
              <strong>金珊</strong>
            </div>
          </section>

          <section className="news-article-section">
            <h2>发展历程</h2>
            <ul>
              {timelineItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="news-article-section">
            <h2>主营业务</h2>
            <ul>
              {businessItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section className="news-article-section">
            <h2>企业文化</h2>
            <div className="news-article-culture-grid">
              {cultureItems.map(([title, content]) => (
                <article key={title}>
                  <h3>{title}</h3>
                  <p>{content}</p>
                </article>
              ))}
            </div>
          </section>

          <section className="news-article-section">
            <h2>企业荣誉</h2>
            <ul className="news-article-honors">
              {honorItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>
        </article>
      </section>

      <BottomSection />
    </main>
  );
}

export default NewsArticlePage;
